import React from "react";



import { classNames } from '../../helpers';

export default function TwAppFooter(props) {
  const { footerTitle = "", footerClass = "", footerActions = [] } = props

  return (
    <footer className={classNames("sticky bottom-0 z-40 w-full max-w-7xl p-4 bg-white border-t-0 border-gray-200 md:flex md:items-center md:justify-between md:p-6", footerClass)}>
      <div className="min-w-0 flex-1">
        <div className="text-md text-gray-900 sm:truncate sm:tracking-tight">
          {footerTitle}
        </div>
      </div>
      <ul className="mt-4 flex gap-3 justify-end shrink-0 md:mt-0 md:ml-4">
        {footerActions.map((data, index) => {
          return (<li key={index}>{data}</li>)
          // return data
        })}
      </ul>
    </footer>
  );
}
